import React, { useState } from "react";
import { Button, Form, Input, message } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import Instance from "../../AxiosConfig";  

const ChangePassword = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { id } = useParams(); 
  const [loading, setLoading] = useState(false);

  const handleChangePassword = async (values) => {
  try {
    setLoading(true);

    const userData = JSON.parse(localStorage.getItem("userData"));
    const token = userData?.token;
    const userId = userData?.id;

    if (!token || !userId) {
      message.error("Please login again.");
      navigate("/login");
      return;
    }
     

    const response = await Instance.put(
      `/profile/change-password/${userId}`,
      {
        oldPassword: values.currentPassword,
        newPassword: values.newPassword,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("Change Password Response:", response.data);

    if (response.data.success) {
      message.success("Password updated successfully!");
      form.resetFields();
      // navigate("/profile");
    } else {
      message.error(response.data.message || "Password update failed.");
    }
  } catch (error) {
    console.error("Error changing password:", error);
    if (error.response?.data?.message) {
      message.error(error.response.data.message);
    } else {
      message.error("Something went wrong.");
    }
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="settings-personal-information">
      <div className="container">
        <h4 className="mt-4 mt-lg-0">Update Password</h4>
        <hr style={{ color: "var(--black-color)" }} />

        <Form
          layout="vertical"
          form={form}
          onFinish={handleChangePassword}  
        >
          <div className="row mt-4">
            <div className="col-md-6 mt-4">
              <Form.Item
                name="currentPassword"
                label="Current Password"
                rules={[
                  { required: true, message: "Current password is required" },
                ]}
              >
                <Input.Password
                  className="settings-input"
                  placeholder="Enter Current Password"
                />
              </Form.Item>
            </div>

            <div className="col-md-6 mt-4">
              <Form.Item
                name="newPassword"
                label="New Password"
                rules={[
                  { required: true, message: "Password is required" },
                  {
                    pattern: /^(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/,
                    message:
                      "Password must be at least 8 characters, include one uppercase letter, one number, and one special character",
                  },
                ]}
              >
                <Input.Password
                  className="settings-input"
                  placeholder="Enter New Password"
                />
              </Form.Item>
            </div>
          </div>

          <div className="row mt-4">
            <div className="d-flex justify-content-end gap-2">
              <Button
                className="status-role-button"
                htmlType="submit"
                loading={loading}
              >
                {loading ? "Saving..." : "Save"}
              </Button>
            </div>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default ChangePassword;
